import cacheLs from "../cacheLs"

export default {
  setCountryList (state, data) {
    state.countryList = data
    cacheLs.set_country_list(data)
  }
}
